"use client";
import { Navigation } from "swiper/modules";
import {
  MotionStackProps,
  MotionTypography,
} from "@/commonComponents/motion-components";
import { ComponentType } from "react";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { Stack } from "@mui/material";
import EnhancedSwiper from "@/commonComponents/enhanced-swiper";
import SwiperNavigationButton from "@/commonComponents/swiper-navigation-button";
import { CaseStudySlide, CaseStudySlideProps } from "./cards/case-study-slide";
import { MaterialSwiperSlideProps } from "./material-components";

export type CaseStudiesProps = {
  SectionHeading?: string;
  data: CaseStudySlideProps[];
  ContainerEndChildrenProps?: Omit<MotionStackProps, "children">;
  SlideComponent?: ComponentType | any;
  SlideComponentProps?: CaseStudiesProps | any;
  SlideWrapperSxProps?: MaterialSwiperSlideProps["sx"];
  hasTopNavigation?: boolean;
  navId?: string;
};

// CaseStudiesSection is needed to improve
const CaseStudiesSection = (props: CaseStudiesProps) => {
  const {
    SectionHeading,
    data,
    ContainerEndChildrenProps,
    SlideWrapperSxProps,
    SlideComponent,
    SlideComponentProps,
    hasTopNavigation = true,
    navId,
  } = props;

  return (
    <SectionWrapper navId={navId || "case-studies"} color={"primary.main"}>
      <Stack width={1}>
        <EnhancedSwiper
          slidesPerView={"auto"}
          navigation={{
            enabled: true,
            nextEl: ".swiper-case-next",
            prevEl: ".swiper-case-prev",
          }}
          modules={[Navigation]}
          SlideWrapperProps={{
            sx: {
              width: { xs: 301, lg: 643 },
              mr: 3,
              ...SlideWrapperSxProps,
            },
          }}
          sx={{
            overflow: { xs: "visible", xxl: "hidden" },
          }}
          SlideComponent={SlideComponent || CaseStudySlide}
          SlideComponentProps={SlideComponentProps}
          data={data}
          Slots={{
            ContainerStartChildren: (
              <Stack
                direction="row"
                alignItems={"center"}
                justifyContent={"space-between"}
                mb={{ xs: 5, md: 6 }}
              >
                <MotionTypography variant="h3">
                  {SectionHeading || "Our Case Studies"}
                </MotionTypography>
                {hasTopNavigation && (
                  <SwiperNavigationButton
                    display={{
                      xs: "none",
                      md: "flex",
                    }}
                    PrevButtonProps={{
                      className: "swiper-case-prev",
                    }}
                    NextButtonProps={{
                      className: "swiper-case-next",
                    }}
                  />
                )}
              </Stack>
            ),
            ContainerEndChildren: (
              <SwiperNavigationButton
                mt={5}
                display={{
                  xs: "flex",
                  md: "none",
                }}
                alignSelf={"center"}
                PrevButtonProps={{
                  className: "swiper-case-prev",
                }}
                NextButtonProps={{
                  className: "swiper-case-next",
                }}
                {...ContainerEndChildrenProps}
              />
            ),
          }}
        />
      </Stack>
    </SectionWrapper>
  );
};

export default CaseStudiesSection;
